import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const WEEKOFYEAR = () => {
  return (
    <CardSection id="WEEKOFYEAR" title="WEEKOFYEAR">
      <Paragraph>
        주어진 날짜/시간 객체에서 주 번호를 정수로 반환합니다. 이는 Excel의
        WEEKNUM 함수와 동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>WEEKOFYEAR(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 날짜/시간 객체입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>WEEKOFYEAR(`DATE`)</Paragraph>
        <Img src="computeWeekOfYear" />
        {/* <Paragraph accent>DATE(`year`, `month`, `day`)</Paragraph> */}
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체 혹은 날짜/시간 객체를
          포함하는 열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
